import { useIsCurrentUserPermittedTo } from "PFCore/helpers/use_is_permitted_to";
import { PermissionRule } from "PFTypes";
import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item/nav_item";

export const HelpNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });

  if (!useIsCurrentUserPermittedTo(PermissionRule.Documentation)) {
    return null;
  }

  return (
    <NavItem
      icon="question"
      isActiveTest={(path) => path.match(/^\/help/)}
      name={t("help")}
      href="/help"
      id="help"
      {...props}
    />
  );
};
